import api from 'Application/api/api';

const editActivity = (signal, values) =>
	api.put('/activity-templates', values, {
		signal,
	});

export default editActivity;
